import { Database, Pencil, Trash2 } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { groupForFamily, ontologyGroupStyles } from '@/frontend/features/Fde/ontologyGraphGroups'
import type { FdeCopy, OntologyClass } from '@/frontend/features/Fde/types'

interface Props {
  ontologyClass: OntologyClass; linkCount: number; actionCount: number; backed: boolean
  copy: FdeCopy; canManage: boolean; onFocus: () => void; onOpenElements: () => void; onEdit: () => void; onDelete: () => void
}

export default function OntologyClassRow(props: Props) {
  const record = props.ontologyClass
  const colors = ontologyGroupStyles[groupForFamily(record.family.key)]
  const elementLabel = record.element_count === 1 ? props.copy.workspace.element : props.copy.workspace.elements.toLocaleLowerCase()
  return <article className="group flex min-h-14 items-center gap-3 px-3 py-2 hover:bg-muted/20">
    <button type="button" onClick={props.onFocus} className="flex min-w-0 flex-1 items-center gap-3 text-left">
      <span className={`size-2 shrink-0 rounded-full ${colors.dot}`} />
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2"><strong className="truncate text-xs font-semibold">{record.name}</strong>{record.source === 'project' && <Badge variant="outline" className="h-5 px-1.5 text-[9px] font-normal text-primary">{props.copy.workspace.project_class}</Badge>}</span>
        <span className="mt-0.5 block truncate text-[10px] text-muted-foreground">{record.description || record.key}</span>
      </span>
    </button>
    <div className="hidden w-[22rem] shrink-0 grid-cols-4 items-center text-[10px] tabular-nums text-muted-foreground 2xl:grid">
      <span>{record.property_schema.length} {props.copy.workspace.schema_properties}</span>
      <span>{props.linkCount} {props.copy.workspace.schema_links}</span>
      <span>{props.actionCount} {props.copy.workspace.schema_actions}</span>
      <span className="flex items-center gap-1.5">{props.backed && <span className="size-1.5 rounded-full bg-emerald-500" />}{props.backed ? props.copy.workspace.schema_backed : props.copy.workspace.schema_no_backing}</span>
    </div>
    <Button type="button" size="sm" variant="ghost" onClick={props.onOpenElements} aria-label={`${record.element_count} ${elementLabel}`}><Database />{record.element_count}</Button>
    {props.canManage && record.source === 'project' && <div className="flex shrink-0 items-center gap-0.5 opacity-60 transition-opacity group-hover:opacity-100">
      <Button type="button" size="icon-sm" variant="ghost" aria-label={props.copy.common.edit} onClick={props.onEdit}><Pencil /></Button>
      <Button type="button" size="icon-sm" variant="ghost" aria-label={props.copy.common.delete} onClick={props.onDelete}><Trash2 className="text-destructive" /></Button>
    </div>}
  </article>
}
